import { useCallback, useRef, useState } from 'react'

export function useSnapshot<T>(value: T): [snapshot: T, takeSnapshot: () => void] {
  const [snapshot, setSnapshot] = useState<T>(value)

  const latestValueRef = useRef<T>(value)
  latestValueRef.current = value

  const takeSnapshot = useCallback(() => {
    setSnapshot(latestValueRef.current)
  }, [])

  return [snapshot, takeSnapshot]
}
